import { render, staticRenderFns } from "./refuse.vue?vue&type=template&id=81034f08&scoped=true"
import script from "./refuse.vue?vue&type=script&lang=js"
export * from "./refuse.vue?vue&type=script&lang=js"
import style0 from "./refuse.vue?vue&type=style&index=0&id=81034f08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81034f08",
  null
  
)

export default component.exports